export default __webpack_public_path__ + "static/media/YAS0720.34I-34465_-18900_0.7ae8e674.jpg";